export type RateBasis = 'monthly' | 'daily';

const DAYS_PER_MONTH = 30;
const DECIMALS = 6;

function round(value: number): number {
  return Number(value.toFixed(DECIMALS));
}

/**
 * Copia de `apps/api/src/current-account/utils/rate-conversion.ts`, sólo para
 * la vista previa del modal mientras se escribe: pedírsela al servidor en cada
 * tecla no vale la pena. La tabla usa siempre lo que devuelve la API. Los tests
 * de los dos lados fijan los mismos valores esperados.
 */
export function toDailyRate(rate: number, basis: RateBasis): number {
  if (basis === 'daily') {
    return round(rate);
  }
  return round((Math.pow(1 + rate / 100, 1 / DAYS_PER_MONTH) - 1) * 100);
}

export function toMonthlyRate(rate: number, basis: RateBasis): number {
  if (basis === 'monthly') {
    return round(rate);
  }
  return round((Math.pow(1 + rate / 100, DAYS_PER_MONTH) - 1) * 100);
}
